import CommonWebAPIUtils from "../utils/commonWebAPIUtils";

export function generateS3Url(input, type) {
    CommonWebAPIUtils._generateS3Url(input, type);
}

export function generateOneTimeOtp(query) {
    CommonWebAPIUtils._generateOneTimeOtp(query);
}
